import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Footer from "./Footer";

import { Row, Col } from "react-bootstrap";
import BottomBarIcons from "./BottomBarIcons";
import Header from "./Header";
import Sidebar from "./Sidebar";
import excelExportIcon from "../assets/img/exportExcelRed.png";
import http from "../api/server";
import ApprovalApproverdash from "./ApprovalApproverdash";
import {
  GET_CLINET_ID_API,
  PROPERTY_DASHBOARD_API,
  DOOR_INSPECTION_API,
  CONTRACT_INSPECTOR_ACCEPTANCE,
  DOWNLOAD_EXCEL_FILE,
} from "../api/apiPath";
import useGetClientId from "../hooks/useGetClientId";
import { Link, useNavigate, generatePath, useParams } from "react-router-dom";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
import { Statuses, UserRoles } from "./common/constant";
import IconButton from "@mui/material/IconButton";
import Iframe from "react-iframe";
import dayjs from "dayjs";
import Toaster from "./common/Toaster";
import { ToastContainer, toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import Icon from "react-multi-date-picker/components/icon";

// import scanDoorIcon from "../assets/img/scanDoorIcon.png";

import { Box, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
// import TableChartIcon from "@mui/icons-material/TableChart";
import StatusPill from "./common/StatusPill";
import DynamicTable from "./common/DynamicTable";
import NewDynamicTable from "./common/NewDynamicTable";
import searchIcon from "../assets/img/searchIcon.png";
import activeNewIcon from "../assets/img/activeNewIcon.png";
import activeEditIcon from "../assets/img/activeEditIcon.png";
import activeViewIcon from "../assets/img/activeViewIcon.png";
import activeDownloadIcon from "../assets/img/activeDownloadIcon.png";

import UploadPropertyImage from "./common/UploadPropertyImage";
import AutocompleteInput from "./common/AutocompleteInput";

// const CustomIcon = (props) => {
//   return (
//     <IconButton onClick={props.openCalendar}>
//       <FilterListIcon sx={{ color: "#EF3800" }} />
//     </IconButton>
//   );
// };

const ApproverDashboard = () => {
  // const { clientNameParam } = useParams();
  const clientObj = useGetClientId();
  const { clientNameParam, inspectionRefnumber } = useParams();
  const [hideSidebar, setHideSidebar] = useState(false);
  const [propertyData, setPropertyData] = useState(null);
  // const [data, setPageData] = useState(null);
  // eslint-disable-next-line no-unused-vars -- setData used in fetchData; data kept for potential use
  const [data, setData] = useState(null);
  //   const [activeData, SetActiveData] = useState(null);
  const [completedData, SetCompletedData] = useState(null);

  // const [autoKey, setAutoKey] = useState(0);
  // 🔹 PROGRESS FILTER STATES
  const [searchTextProgress, setSearchTextProgress] = useState("");
  const [propertyNameProgress, setPropertyNameProgress] =
    useState("Property Name");

  const STORAGE_KEY = "toolbarValue";
  
  const [showModal, setShowModal] = useState(false);
  const [InspectorProgress, setInspectorProgress] = useState("Inspector");
  const [statusProgress, setStatusProgress] = useState("Status");
  const [selectedRow, setSelectedRow] = useState(null);
  // 🔹 COMPLETED FILTER STATES
  const [searchTextCompleted, setSearchTextCompleted] = useState("");
  const [propertyNameCompleted, setPropertyNameCompleted] =
    useState("Property Name");
  const [InspectorCompleted, setInspectorCompleted] = useState("Inspector");
  const [statusCompleted, setStatusCompleted] = useState("Status");
  const [date, setDate] = useState("Date");

  const [showApproveModal, setShowApproveModal] = useState(false);
  // const [progressSurveyData, setProgressSurveyData] = useState([]);
  // const [completedSurveyData, setCompletedSurveyData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userObj } = useSelector((state) => state.user);
  const [userRole, setUserRole] = useState(null);
  // eslint-disable-next-line no-unused-vars -- setters used in fetchData; values kept for potential use
  const [inspectorTileInfo, setinspectorTileInfo] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [adminInspectionInfo, setadminInspectionInfo] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [adminDashboardInfo, setAdminDashboardInfo] = useState(null);
  const [dashboardTiles, setDashboardTiles] = useState(null);
  // const [filteredRows, setFilteredRows] = useState(null);
  // const [dateRange, setDateRange] = useState([null, null]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  //   const [activeTab, setActiveTab] = useState("Active");
  const [showLoader, setShowLoader] = useState(false);
  const [showPropertyImageModal, setShowPropertyImageModal] = useState(false);
  const [showPropertyImageDetails, setShowPropertyImageDetails] =
    useState(null);
  const [showPropertyAcceptDetails, setShowPropertyAcceptDetails] =
    useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showAcceptPopup, setShowAcceptPopup] = useState(false);
  const [acceptFormData, setAcceptFormData] = useState({
    status: "Select",
    comment: "",
  });
  // const [inspectorOptions, setInspectorOptions] = useState([]);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [exportLoadingRowId, setExportLoadingRowId] = useState(null);
  const [downloadMenuAnchor, setDownloadMenuAnchor] = useState(null);
  const [downloadMenuRow, setDownloadMenuRow] = useState(null);
  const [validationFlag, setValidationFlag] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastType: "",
      toastString: "",
    });
  };

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const navigate = useNavigate();

  // const siteList = [
  //   ...new Map(
  //     propertyData?.map((item) => [
  //       item.propertyName,
  //       { name: item.propertyName },
  //     ]),
  //   ).values(),
  // ];

  // const [toolbar, setToolBar] = useState({
  //   searchText: "",
  //   propertyName: "Property Name",
  //   inspector: "Inspector",
  //   status: "Status",
  // });

  const isAnyFilterAppliedOnProgress =
    searchTextProgress !== "" ||
    propertyNameProgress !== "Property Name" ||
    InspectorProgress !== "Inspector" ||
    statusProgress !== "Status";

  const isAnyFilterAppliedOnCompleted =
    searchTextCompleted !== "" ||
    propertyNameCompleted !== "Property Name" ||
    InspectorCompleted !== "Inspector" ||
    statusCompleted !== "Status" ||
    date !== "Date";

  // useEffect(() => {
  //   if (propertyData) {
  //     const tempfilteredRows = propertyData?.filter((item) => {
  //       const matchesSearch =
  //         !toolbar.searchText ||
  //         item.propertyName
  //           ?.toLowerCase()
  //           .includes(toolbar.searchText.toLowerCase()) ||
  //         item.blockName
  //           ?.toLowerCase()
  //           .includes(toolbar.searchText.toLowerCase()) ||
  //         item.propertyLocation
  //           ?.toLowerCase()
  //           .includes(toolbar.searchText.toLowerCase()) ||
  //         item.cityName
  //           ?.toLowerCase()
  //           .includes(toolbar.searchText.toLowerCase()) ||
  //         item.inspectionReferenceNumber
  //           ?.toLowerCase()
  //           .includes(toolbar.searchText.toLowerCase()) ||
  //         item.status
  //           ?.toLowerCase()
  //           .includes(toolbar.searchText.toLowerCase()) ||
  //         item.inspectedBy
  //           ?.toLowerCase()
  //           .includes(toolbar.searchText.toLowerCase());

  //       const matchesPropertyName =
  //         toolbar.propertyName === "Property Name" ||
  //         item.propertyName.toLowerCase() ===
  //           toolbar.propertyName.toLowerCase();

  //       const matchesInspector =
  //         toolbar.inspector === "Inspector" ||
  //         item.inspectedBy
  //           ?.toLowerCase()
  //           .includes(toolbar.inspector.toLowerCase());

  //       const matchesStatus =
  //         toolbar.status === "Status" || item.status === toolbar.status;
  //       const rawdate =
  //         item.scheduledInspectionDate != null
  //           ? new Date(item.scheduledInspectionDate).toLocaleDateString("en-GB")
  //           : null;
  //       const [day, month, year] =
  //         rawdate != null ? rawdate.split("/") : [null, null, null];
  //       const rowDate =
  //         rawdate != null ? stripTime(`${year}-${month}-${day}`) : null;
  //       const [start, end] = dateRange;

  //       const matchesDate =
  //         start === null ||
  //         end === null ||
  //         ((!start || rowDate >= stripTime(start)) &&
  //           (!end || rowDate <= stripTime(end)));

  //       return (
  //         matchesSearch &&
  //         matchesPropertyName &&
  //         matchesInspector &&
  //         matchesStatus &&
  //         matchesDate
  //       );
  //     });
  //     setFilteredRows(tempfilteredRows);
  //   } else {
  //     setFilteredRows(propertyData);
  //   }
  // }, [propertyData, toolbar, dateRange]);

  // const stripTime = (date) => {
  //   const d = new Date(date);
  //   d.setHours(0, 0, 0, 0);
  //   return d;
  // };

  useEffect(() => {
    if (userObj || refresh === true) {
      const fetchData = async () => {
        try {
          const responseClient = await http.get(
            GET_CLINET_ID_API + "/" + userObj?.userId,
          );
          setUserRole(responseClient?.data?.roleId);
          const response = await http.get(
            PROPERTY_DASHBOARD_API +
              "clientId=" +
              responseClient?.data?.clientId +
              "&userId=" +
              userObj.userId,
          );

          if (!response.status) {
            throw new Error(`HTTP error! status: ${response?.message}`);
          }
          const result = await response?.data;
          setData(result);
          const adminData = result?.adminApproverTotalInspections;
          setadminInspectionInfo(adminData);
          if (
            result?.propertyFields != null &&
            result?.propertyFields.length > 0
          ) {
            const tempProgress = result?.propertyFields;
            tempProgress?.forEach((item) => {
              item.id = item.inspectionMasterId; // Assigning a sequential ID
              item.formattedScheduledDate = new Date(
                item.scheduledInspectionDate,
              ).toLocaleDateString("en-US");
            });
            // const inspectorArr =
            // tempProgress?.map((user) => user.inspectedBy) ?? [];
            // const unique = [
            //   ...new Set(
            //     inspectorArr.flatMap((item) =>
            //       item != null && typeof item === "string"
            //         ? item.split(",").map((name) => name.trim())
            //         : [],
            //     ),
            //   ),
            // ].filter(Boolean);
            // setInspectorOptions(unique);
            // const activeProperties = tempProgress.filter(
            //   (item) => item.status !== Statuses.COMPLETED,
            // );
            // SetActiveData(activeProperties);
            const completedProperties = tempProgress.filter(
              (item) => item.status === Statuses.COMPLETED,
            );
            // setPropertyData(activeProperties);
            setPropertyData(tempProgress);
            SetCompletedData(completedProperties);
            {
              console.log(completedData);
            }

            // setActiveTab("Active");
          }
          setadminInspectionInfo(result?.adminApproverTotalInspections);
          setinspectorTileInfo(result?.inspectorsTotalInspections);
          setAdminDashboardInfo(result?.adminDashboardInfos);

          const tempDashboardTiles = [];
          if (responseClient?.data?.roleId === UserRoles.INSPECTOR) {
            if (result?.inspectorsTotalInspections !== null) {
              tempDashboardTiles.push(
                {
                  title: "Total Inspections Assigned",
                  count:
                    result?.inspectorsTotalInspections
                      ?.totalInspectionAssigned || 0,
                  icon: "bi bi-door-closed",
                  statusText: "All",
                },
                {
                  title: "Total Doors Surveyed",
                  count:
                    result?.inspectorsTotalInspections?.totalDoorSurveyed || 0,
                  icon: "bi bi-check-circle text-success",
                  statusText: "All",
                },
                {
                  title: "Total Inspections In Progress",
                  count:
                    result?.inspectorsTotalInspections
                      ?.totalInspectionsInProgress || 0,
                  icon: "bi bi-x-circle text-warning",
                  statusText: "In Progress",
                },
                {
                  title: "Total Inspections Approved",
                  count:
                    result?.inspectorsTotalInspections
                      ?.totalInspectionApproved || 0,
                  icon: "bi bi-exclamation-triangle text-danger",
                  statusText: "Approved",
                },
              );
            }
          } else if (
            responseClient?.data?.roleId === UserRoles.APPROVER ||
            responseClient?.data?.roleId === UserRoles.ADMIN
          ) {
            if (result?.adminApproverTotalInspections !== null) {
              tempDashboardTiles.push(
                {
                  title: "Total Inspections",
                  count:
                    result?.adminApproverTotalInspections?.totalInspections ||
                    0,
                  icon: "bi bi-door-closed",
                  statusText: "All",
                },
                {
                  title: "Total Doors Surveyed",
                  count:
                    result?.adminApproverTotalInspections?.totalDoorSurveyed ||
                    0,
                  icon: "bi bi-check-circle text-success",
                  statusText: "Approved",
                },
                {
                  title: "Total Inspections Under Review",
                  count:
                    result?.adminApproverTotalInspections
                      ?.totalInspectionUnderReview || 0,
                  icon: "bi bi-x-circle text-warning",
                  statusText: "Under Review",
                },
                {
                  title: "Total Inspections Approved",
                  count:
                    result?.adminApproverTotalInspections
                      ?.totalApprovedInspection || 0,
                  icon: "bi bi-exclamation-triangle text-danger",
                  statusText: "Rejected",
                },
              );
            }
          }
          setDashboardTiles(tempDashboardTiles);
          console.log(dashboardTiles);
        } catch (err) {
          setError(err?.data);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [userObj, refresh]);

  const progressData =
    propertyData?.filter((item) => item.status !== Statuses.COMPLETED) || [];

  const completedDataList =
    propertyData?.filter((item) => item.status === Statuses.COMPLETED) || [];

  //   const handleTabChange = (e) => {
  //     setActiveTab(e);
  //     setPropertyData(e === "Active" ? activeData : completedData);
  //   };

  const handleDownloadClick = async (row) => {
    setLoadingRowId(row.id);
    try {
      const response = await http.get(DOOR_INSPECTION_API, {
        params: {
          propertyId: row.propertyMasterId,
          inspectionReferenceNumber: row.inspectionReferenceNumber,
        },
        responseType: "blob",
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      setPdfUrl(fileURL);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `${row?.propertyMasterId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true); // 👉 show modal
      }
      return true;
    } catch (error) {
      console.error("Download Failed", error);
      return true;
    } finally {
      setLoadingRowId(null);
      // setRefresh((prev) => !prev);
    }
  };

  const handleExportActionItems = async (row) => {
    setDownloadMenuAnchor(null);
    setDownloadMenuRow(null);
    setExportLoadingRowId(row?.id);
    try {
      const payload = {
        clientId: clientObj?.clientId,
        propertyMasterId: null,
        searchText: row?.inspectionReferenceNumber || null,
        idSearch: null,
        priority: null,
        status: null,
        dueFrom: null,
        dueTo: null,
        pageNumber: 1,
        pageSize: 100,
      };
      const response = await http.post(DOWNLOAD_EXCEL_FILE, payload, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "ActionItems.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?([^;]+)/,
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/"/g, ""));
        }
      }
      if (
        navigator.userAgent.includes("Safari") &&
        !navigator.userAgent.includes("Chrome")
      ) {
        const reader = new FileReader();

        reader.onloadend = () => {
          const link = document.createElement("a");
          link.href = reader.result;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
        };

        reader.readAsDataURL(blob);
      } else{
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

      }
      toast.success("Excel file downloaded successfully.", {
        containerId: "property-form-export",
        position: "top-center",
        autoClose: 2000,
        theme: "dark",
        closeOnClick: true,
      });
    } catch (err) {
      console.error(err);
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to download Excel file";
      toast.error(message, {
        containerId: "property-form-export",
        position: "top-center",
        autoClose: 2000,
        theme: "dark",
        closeOnClick: true,
      });
    } finally {
      setExportLoadingRowId(null);
    }
  };

  const handleDownloadMenuOpen = (event, row) => {
    event.stopPropagation();
    setDownloadMenuAnchor(event.currentTarget);
    setDownloadMenuRow(row);
  };

  const handleDownloadMenuClose = () => {
    setDownloadMenuAnchor(null);
    setDownloadMenuRow(null);
  };

  // 🔹 PROGRESS
  const propertyNameProgressList = [
    ...new Set(progressData.map((item) => item.propertyName).filter(Boolean)),
  ].map((item) => ({ name: item }));

  // const inspectorProgressList = [
  //   ...new Set(progressData.map((item) => item.inspectedBy).filter(Boolean)),
  // ].map((item) => ({ name: item }));
  const inspectorProgressList = [
    ...new Set(
      progressData.flatMap((item) =>
        item.inspectedBy
          ? item.inspectedBy.split(",").map((i) => i.trim())
          : [],
      ),
    ),
  ].map((item) => ({ name: item }));

  const propertyNameCompletedList = [
    ...new Set(
      completedDataList
        .map((item) => item.propertyName?.trim())
        .filter(Boolean),
    ),
  ].map((item) => ({ name: item }));

  // const inspectorCompletedList = [
  //   ...new Set(
  //     completedDataList.map((item) => item.inspectedBy).filter(Boolean),
  //   ),
  // ].map((item) => ({ name: item }));
  const inspectorCompletedList = [
    ...new Set(
      completedDataList.flatMap((item) =>
        item.inspectedBy
          ? item.inspectedBy.split(",").map((i) => i.trim())
          : [],
      ),
    ),
  ].map((item) => ({ name: item }));

  const toCalendarDay = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, "0");
    const day = String(d.getUTCDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const tableProgressColumns = [
    {
      field: "Actions",
      headerName: "Actions",
      width: 50,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      type: "string",
      minWidth: 50,
      flex: 0.4,
      renderCell: (data) => {
        const showNewSurveyIcon = checkShowNewSurveyIcon(data?.row);
        const showAcceptIcon = checkShowAccepticon(data?.row);
        const showThisLoader =
          loadingRowId === data?.row.id || exportLoadingRowId === data?.row.id;
        return (
          <Box style={{ display: "flex", alignItems: "center" }}>
            {showAcceptIcon && (
              <img
                src={activeEditIcon}
                alt="Accept/Reject Inspection"
                title="Accept/Reject Inspection"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setShowAcceptPopup(true);
                  setShowPropertyAcceptDetails(data?.row);
                }}
              ></img>
            )}
            {showNewSurveyIcon && (
              <img
                tabIndex={0}
                title="New Survey"
                alt="New Survey"
                src={activeNewIcon}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  checkPropertyImage(data?.row);
                }}
              ></img>
            )}
            {showThisLoader ? (
              <div
                className="loader"
                style={{ height: "1.1rem", width: "1.1rem" }}
              ></div>
            ) : (
              <IconButton
                size="small"
                aria-label="Actions"
                title="View, Download PDF, Export Action Items"
                onClick={(e) => handleDownloadMenuOpen(e, data?.row)}
                sx={{ padding: "4px" }}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        );
      },
    },
    {
      field: "propertyName",
      height: 50,
      width: 170,
      minWidth: 170,
      headerName: "Building Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    // {
    //   field: "propertyLocation",
    //   height: 50,
    //   width: 200,
    //   minWidth: 200,
    //   headerName: "Address",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: true,
    //   filterable: true,
    //   flex: 1,
    //   type: "string",
    // },
    // {
    //   field: "inspectionReferenceNumber",
    //   width: 160,
    //   height: 50,
    //   headerName: "Inspection Number",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   filterable: true,
    //   sortable: true,
    //   type: "string",
    //   minWidth: 160,
    //   flex: 1,
    // },
    {
      field: "inspectedBy",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Assigned Inspector(s)",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    // {
    //   field: "approvalDueDate",
    //   width: 160,
    //   height: 50,
    //   headerName: "Approval Target Date",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   filterable: true,
    //   sortable: true,
    //   disableColumnMenu: true,
    //   type: "string",
    //   minWidth: 160,
    //   flex: 1.3,

    //   renderHeader: () => (
    //     <span style={{ display: "flex", alignItems: "center" }}>
    //       <span className="personalFont">Approval Target Date</span>
    //       <i
    //         className="bi bi-info-circle"
    //         style={{ fontSize: "0.9rem", marginLeft: "5px", cursor: "pointer" }}
    //         title="Inspection Approval Target Date"
    //       ></i>
    //     </span>
    //   ),

    //   renderCell: (params) => {
    //     return params.value
    //       ? new Date(params.value).toLocaleDateString("en-US")
    //       : "N/A";
    //   },
    // },
    // {
    //   field: "formattedScheduledDate",
    //   width: 150,
    //   height: 50,
    //   headerName: "Scheduled Date",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   filterable: true,
    //   sortable: true,
    //   type: "string",
    //   minWidth: 150,
    //   flex: 1,
    //   renderCell: (data) => {
    //     const status = data?.row?.status;
    //     const isScheduled = status === Statuses.NEW ? false : true;
    //     return isScheduled ? data.row.formattedScheduledDate : "N/A";
    //   },
    // },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => {
        const status = params.value;
        return <StatusPill status={status} row={params.row} />;
      },
      // renderCell: (params) => {
      //   const status = params.value;
      //   const dueDate = params.row.approvalDueDate
      //     ? new Date(params.row.approvalDueDate)
      //     : null;

      //   const today = new Date();

      //   today.setHours(0, 0, 0, 0);
      //   if (dueDate) dueDate.setHours(0, 0, 0, 0);

      //   const isOverdue =
      //     dueDate &&
      //     today > dueDate &&
      //     status !== Statuses.COMPLETED &&
      //     status !== Statuses.REJECTED;

      //   return isOverdue ? (
      //     <StatusPill status={Statuses.OVERDUE} />
      //   ) : (
      //     <StatusPill status={status} />
      //   );
      // },
    },
    {
      field: "actionItemsCount",
      height: 50,
      width: 140,
      minWidth: 140,
      headerName: "Action Items",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
      renderCell: (params) => {
        return (
          <span
            style={{
              cursor: "pointer",
            }}
            onClick={() => handleActionItemClick(params.row)}
          >
            {params.value}
          </span>
        );
      },
    },
  ];

  const tableCompletedColumns = [
    {
      field: "Actions",
      headerName: "Actions",
      width: 50,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      type: "string",
      minWidth: 50,
      flex: 0.4,
      renderCell: (data) => {
        const showNewSurveyIcon = checkShowNewSurveyIcon(data?.row);
        const showAcceptIcon = checkShowAccepticon(data?.row);
        const showThisLoader =
          loadingRowId === data?.row.id || exportLoadingRowId === data?.row.id;
        return (
          <Box style={{ display: "flex", alignItems: "center" }}>
            {showAcceptIcon && (
              <img
                src={activeEditIcon}
                alt="Accept/Reject Inspection"
                title="Accept/Reject Inspection"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setShowAcceptPopup(true);
                  setShowPropertyAcceptDetails(data?.row);
                }}
              ></img>
            )}
            {showNewSurveyIcon && (
              <img
                tabIndex={0}
                title="New Survey"
                alt="New Survey"
                src={activeNewIcon}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  checkPropertyImage(data?.row);
                }}
              ></img>
            )}
            {showThisLoader ? (
              <div
                className="loader"
                style={{ height: "1.1rem", width: "1.1rem" }}
              ></div>
            ) : (
              <IconButton
                size="small"
                aria-label="Actions"
                title="View, Download PDF, Export Action Items"
                onClick={(e) => handleDownloadMenuOpen(e, data?.row)}
                sx={{ padding: "4px" }}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        );
      },
    },
    {
      field: "propertyName",
      height: 50,
      width: 170,
      minWidth: 170,
      headerName: "Building Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    // {
    //   field: "propertyLocation",
    //   height: 50,
    //   width: 200,
    //   minWidth: 200,
    //   headerName: "Address",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: true,
    //   filterable: true,
    //   flex: 1,
    //   type: "string",
    // },
    // {
    //   field: "inspectionReferenceNumber",
    //   width: 160,
    //   height: 50,
    //   headerName: "Inspection Number",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   filterable: true,
    //   sortable: true,
    //   type: "string",
    //   minWidth: 160,
    //   flex: 1,
    // },
    {
      field: "inspectedBy",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Assigned Inspector(s)",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "approvalDueDate",
      width: 160,
      height: 50,
      headerName: "Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      disableColumnMenu: true,
      type: "string",
      minWidth: 160,
      flex: 1.3,

      renderHeader: () => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span className="personalFont"> Date</span>
          {/* <i
            className="bi bi-info-circle"
            style={{ fontSize: "0.9rem", marginLeft: "5px", cursor: "pointer" }}
            title=" Date"
          ></i> */}
        </span>
      ),

      renderCell: (params) => {
        return params.value
          ? new Date(params.value).toLocaleDateString("en-US")
          : "N/A";
      },
    },
    // {
    //   field: "formattedScheduledDate",
    //   width: 150,
    //   height: 50,
    //   headerName: "Scheduled Date",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   filterable: true,
    //   sortable: true,
    //   type: "string",
    //   minWidth: 150,
    //   flex: 1,
    //   renderCell: (data) => {
    //     const status = data?.row?.status;
    //     const isScheduled = status === Statuses.NEW ? false : true;
    //     return isScheduled ? data.row.formattedScheduledDate : "N/A";
    //   },
    // },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => {
        const status = params.value;
        return <StatusPill status={status} row={params.row} />;
      },

      // renderCell: (params) => {
      //   const status = params.value;
      //   const dueDate = params.row.approvalDueDate
      //     ? new Date(params.row.approvalDueDate)
      //     : null;

      //   const today = new Date();

      //   today.setHours(0, 0, 0, 0);
      //   if (dueDate) dueDate.setHours(0, 0, 0, 0);

      //   const isOverdue =
      //     dueDate &&
      //     today > dueDate &&
      //     status !== Statuses.COMPLETED &&
      //     status !== Statuses.REJECTED;

      //   return isOverdue ? (
      //     <StatusPill status={Statuses.OVERDUE} />
      //   ) : (
      //     <StatusPill status={status} />
      //   );
      // },
    },

    {
      field: "actionItemsCount",
      height: 50,
      width: 140,
      minWidth: 140,
      headerName: "Action Items",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
      renderCell: (params) => {
        return (
          <span
            style={{
              cursor: "pointer",
            }}
            onClick={() => handleActionItemClick(params.row)}
          >
            {params.value}
          </span>
        );
      },
    },
  ];
  const progressColumns = tableProgressColumns;

  const completedColumns = tableCompletedColumns;

  const checkPropertyImage = (row) => {
    row?.propertyImage?.trim() === "" || row?.propertyImage === null
      ? setShowPropertyImageModal(true)
      : gotoDashBoard(row);
    setShowPropertyImageDetails(row);
  };

  const handleCancel = () => {
    setShowPropertyImageModal(false);
    setShowPropertyImageDetails(null);
  };

  const handleActionItemClick = (row) => {
    const temotoolbar = {
      searchText: "",
      actionId: "",
      priority: "",
      status: "",
      dueDate: "",
      dueFrom: "",
      dueTo: "",
      propertyId: row.propertyMasterId,
      pageSize: 100,
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(temotoolbar));

    const pathTemplate = "/client/:clientNameParam/actionRemediation";

    const fullPath = generatePath(pathTemplate, {
      clientNameParam,
    });

    navigate(fullPath, {
      state: {
        propertyName: row.propertyName,
        propertyMasterId: row.propertyMasterId,
      },
    });
  };

  const handleImageUploadSuccess = (propId, InspRef) => {
    setShowPropertyImageModal(false);
    setShowPropertyImageDetails(null);
    //go to scan qr code
    const pathTemplate =
      "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";

    const params = {
      clientNameParam,
      propertyMasterId: propId,
      inspectionRefnumber: InspRef,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const checkShowAccepticon = (row) => {
    if (
      userRole === UserRoles.INSPECTOR &&
      row.status === Statuses.PENDINGINSPECTORAPPROVAL &&
      row.inspectionAccepted === null
    ) {
      return true; //set to false for prod
    } else {
      return false;
    }
  };

  const handleCancelAccept = () => {
    setShowAcceptPopup(false);
    setShowPropertyAcceptDetails(null);
  };

  const handleStatusChange = (e) => {
    setAcceptFormData({
      ...acceptFormData,
      status: e.target.value,
    });
  };
  const handleFormDataChange = (e) => {
    setAcceptFormData({ ...acceptFormData, comment: e.target.value });
  };

  const filteredRowsProgress = progressData.filter((row) => {
    const matchesSearch =
      !searchTextProgress ||
      row.propertyName
        ?.toLowerCase()
        .includes(searchTextProgress.toLowerCase()) ||
      row.status?.toLowerCase().includes(searchTextProgress.toLowerCase()) ||
      row.inspectedBy?.toLowerCase().includes(searchTextProgress.toLowerCase());

    const matchesProperty =
      propertyNameProgress === "Property Name" ||
      row.propertyName === propertyNameProgress;

    // const matchesInspector =
    //   InspectorProgress === "Inspector" ||
    //   row.inspectedBy === InspectorProgress;

    const matchesInspector =
      InspectorProgress === "Inspector" ||
      row.inspectedBy?.includes(InspectorProgress);

    const matchesStatus =
      statusProgress === "Status" || row.status === statusProgress;

    return (
      matchesSearch && matchesProperty && matchesInspector && matchesStatus
    );
  });

  const filteredRowsCompleted = completedDataList.filter((row) => {
    const matchesSearch =
      !searchTextCompleted ||
      row.propertyName
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase()) ||
      row.status?.toLowerCase().includes(searchTextCompleted.toLowerCase()) ||
      row.inspectedBy
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase());

    const matchesProperty =
      propertyNameCompleted === "Property Name" ||
      row.propertyName?.trim() === propertyNameCompleted?.trim();

    const matchesInspector =
      InspectorCompleted === "Inspector" ||
      row.inspectedBy?.includes(InspectorCompleted);

    const matchesStatus =
      statusCompleted === "Status" || row.status === statusCompleted;

    const matchDate =
      date === "Date" ||
      (row.approvalDueDate && toCalendarDay(row.approvalDueDate) === date);

    return (
      matchesSearch &&
      matchesProperty &&
      matchesInspector &&
      matchesStatus &&
      matchDate
    );
  });
  const handleAcceptValidation = async () => {
    let isValid = true;
    // Basic validation
    if (!acceptFormData.status || acceptFormData.status === "Select") {
      isValid = false;
    }
    if (
      acceptFormData.status === "Rejected" &&
      (!acceptFormData.comment || acceptFormData.comment.trim() === "")
    ) {
      isValid = false;
    }
    setValidationFlag(!isValid);
    if (isValid) {
      setShowLoader(true);
      const payload = {
        inspectorUserId: userObj?.userId,
        inspectionMasterId: showPropertyAcceptDetails.inspectionMasterId,
        isAccepted: acceptFormData.status === "Accepted" ? true : false,
        rejectReason: acceptFormData.comment,
      };
      try {
        const response = await http.post(
          CONTRACT_INSPECTOR_ACCEPTANCE,
          payload,
        );

        if (response.status === 200) {
          setShowLoader(false);
          setShowAcceptPopup(false);
          setRefresh((prev) => !prev);
          setTimeout(() => {
            setRefresh((prev) => !prev);
          }, 100);
          const message =
            acceptFormData.status === "Accepted"
              ? "Inspection accepted successfully."
              : "Inspection rejected successfully.";
          setTimeout(() => {
            setToastData({
              toastShow: true,
              toastType: "success",
              toastString: message,
            });
          }, 2000);
        } else {
          setShowLoader(false);
          setShowAcceptPopup(false);

          setTimeout(() => {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: "Error in submitting acceptance. Please try again.",
            });
          }, 2000);
        }
      } catch (err) {
        console.error("Error in submitting acceptance:", err);
        setShowLoader(false);
        setShowAcceptPopup(false);
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in submitting acceptance. Please try again.",
          });
        }, 2000);
      }
    }
  };

  const gotoDashBoard = (row) => {
    // const pathTemplate = "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber";
    const pathTemplate =
      "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: row?.propertyMasterId,
      inspectionRefnumber: row?.inspectionReferenceNumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoPropertyView = (propertyId, data) => {
    const pathTemplate =
      "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyId,
      inspectionRefnumber: data.inspectionReferenceNumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath, {
      state: { showPropertyAcceptDetails: data, userRole: userRole },
    });
  };

  const checkShowDownloadicon = (row) => {
    if (
      row.status !== Statuses.SCHEDULED &&
      row.status !== Statuses.NEW &&
      row.status !== Statuses.PENDINGINSPECTORAPPROVAL &&
      row.status !== null &&
      row.status !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkShowNewSurveyIcon = (row) => {
    const scheDate = new Date(row.scheduledInspectionDate);
    const todayDate = new Date();

    // Normalize to date-only strings
    const d1 = dayjs(scheDate).format("YYYY-MM-DD");
    const d2 = dayjs(todayDate).format("YYYY-MM-DD");

    // Compare as strings
    const isBeforeOrSame = d1 <= d2;
    if (
      (userRole === UserRoles.INSPECTOR || userRole === UserRoles.ADMIN) &&
      (row?.status === Statuses.SCHEDULED ||
        row?.status === Statuses.INPROGRESS) &&
      isBeforeOrSame &&
      new Date(row.scheduledInspectionDate).getFullYear() >
        new Date().getFullYear() - 1
    ) {
      return true;
    } else {
      return false;
    }
  };
  // if (loading) return <p>Loading...</p>;
  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );
  // const handleApprovalModalOpen = () => {
  //   setShowApproveModal(true);
  // };
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <ToastContainer
        containerId="property-form-export"
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        draggable
        pauseOnHover
        theme="dark"
      />
      {userObj && (
        <div className="dashboard_body_main d-flex">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}

          {/* <div className="d-flex dashboard_body flex-column py-3 w-100"> */}
          <div className="d-flex dashboard_body flex-column py-3 w-100">
            <>
              <div className="p-3 mb-4 orange-box d-flex gap-2">
                <div className="py-3 ps-3 pe-6 d-flex flex-column align-items-start text-start ms-3">
                  <p className="mb-0 align-self-center text-center orange-box-number">
                    {/* {(dashboardTiles && dashboardTiles[0]?.count) || 0} */}
                    {adminInspectionInfo?.totalApprovedInspection || 0}
                  </p>
                  <p
                    className="mb-0"
                    style={{ fontSize: "1rem", fontWeight: "600" }}
                  >
                    Total Approved
                  </p>
                </div>
                <div className="black-line"></div>

                <div className="py-3 d-flex flex-row">
                  <div className="px-3 d-flex flex-column align-items-start text-start">
                    <p className="mb-0 align-self-center text-center orange-box-number">
                      {/* {(dashboardTiles && dashboardTiles[1]?.count) || 0} */}
                      {adminInspectionInfo?.totalRejectedInspection || 0}
                    </p>
                    <p
                      className="mb-0"
                      style={{ fontSize: "1rem", fontWeight: "600" }}
                    >
                      Total Rejected
                    </p>
                  </div>
                  <div className="px-3 d-flex flex-column align-items-start text-start">
                    <p className="mb-0 align-self-center text-center orange-box-number">
                      {/* {(dashboardTiles && dashboardTiles[2]?.count) || 0} */}
                      {adminInspectionInfo?.totalInspectionUnderReview || 0}
                    </p>
                    <p
                      className="mb-0 align-self-center text-center"
                      style={{ fontSize: "1rem", fontWeight: "600" }}
                    >
                      Total Pending
                    </p>
                  </div>
                  <div className="px-3 d-flex flex-column align-items-start text-start">
                    <p className="mb-0 align-self-center text-center orange-box-number">
                      {/* {userRole === UserRoles.ADMIN ||
                      userRole === UserRoles.APPROVER
                        ? dashboardTiles?.[3]?.count
                        : dashboardTiles?.[3]?.count} */}
                      {adminInspectionInfo?.totalInspections || 0}
                    </p>
                    <p
                      className="mb-0"
                      style={{ fontSize: "1rem", fontWeight: "600" }}
                    >
                      Total Assigned
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="row m-0">
                {dashboardTiles &&
                  dashboardTiles?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="col-6 col-sm-6 col-lg-3 col-md-3 mb-3"
                        onClick={() => {
                          setSelectedTile(index);
                          setStatusFilter(item?.statusText);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className={
                            selectedTile === index
                              ? "card text-bg-primary bulid_card_selected"
                              : "card text-bg-primary bulid_card"
                          }
                        >
                          <div className="card-body text-center d-flex flex-column gap-2">
                            <i className={item?.icon}></i>
                            <strong className="fs-5">{item?.count || 0}</strong>
                            <small>{item?.title}</small>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div> */}
              <div
                className="dashboard_header dashboard_header_inspection d-flex mb-3"
                style={{ textAlign: "justify" }} //marginTop: "37px" }}
              ></div>
              {/* <div className="mb-3 tab-container">
                <button
                  className={
                    activeTab === "Active"
                      ? "btn btn-tab-active"
                      : "btn btn-tab"
                  }
                  onClick={() => handleTabChange("Active")}
                >
                  Active Inspections
                </button>
                <button
                  className={
                    activeTab === "Completed"
                      ? "btn btn-tab-active"
                      : "btn btn-tab"
                  }
                  onClick={() => handleTabChange("Completed")}
                >
                  Completed Inspections
                </button>
              </div> */}

              <Row>
                {/* LEFT → Progress */}
                <Col md={6}>
                  <div className="dashboard-bar py-3">
                    <h2 className="mt-0 mb-3 text-start fw-bold">
                      Approver Progress
                    </h2>
                    <div className="row align-items-center g-3 mt-1">
                      <div className="row" style={{ marginLeft: "-15px" }}>
                        <div className="custom_toolbar_search col-md-6">
                          <img src={searchIcon} />
                          <input
                            type="text"
                            className="form-control custom_toolbar_control"
                            id="floatingInput"
                            placeholder="Search..."
                            value={searchTextProgress}
                            onChange={(e) =>
                              setSearchTextProgress(e.target.value)
                            }
                          />
                        </div>
                        <button
                          className="btn-primary shadow "
                          style={{ width: "150px", height: "36px" }}
                          disabled={
                            !selectedRow ||
                            selectedRow?.status !==
                              Statuses.SUBMITTEDFORAPPROVAL
                          }
                          onClick={() => {
                            setShowPropertyAcceptDetails(selectedRow);
                            setShowApproveModal(true);
                          }}
                        >
                          Approve Survey
                        </button>

                        <button
                          className="btn-secondary shadow ms-2"
                          style={{ width: "150px", height: "36px" }}
                          disabled={
                            !selectedRow ||
                            selectedRow?.status !==
                              Statuses.SUBMITTEDFORAPPROVAL
                          }
                          onClick={() => {
                            setShowPropertyAcceptDetails(selectedRow);
                            setShowModal(true);
                          }}
                        >
                          Reject Survey
                        </button>
                      </div>

                      <div className="col-6 col-md-4">
                        {/* <select
                      className="form-select form-control"
                      value={propertyNameProgress}
                      onChange={(e) => setPropertyNameProgress(e.target.value)}
                    >
                      <option>Property Name</option>
                      {[
                        ...new Set(
                          progressSurveyData.map((user) => user.propertyName)
                        ),
                      ].map((propertyName, index) => (
                        <option key={index} value={propertyName}>
                          {propertyName}
                        </option>
                      ))}
                    </select> */}
                        <AutocompleteInput
                          masterList={propertyNameProgressList}
                          getOptionLabel={(item) => item?.name || ""}
                          getOptionValue={(item) => item?.name || ""}
                          value={
                            propertyNameProgress === "Property Name"
                              ? ""
                              : propertyNameProgress
                          }
                          onValueChange={(value) =>
                            setPropertyNameProgress(value || "Property Name")
                          }
                          placeholder="Building  Name"
                          inputClassName="form-control"
                        />
                      </div>

                      <div className="col-6 col-md-3">
                        {/* <select
                      className="form-select form-control"
                      value={InspectorProgress}
                      onChange={(e) => setInspectorProgress(e.target.value)}
                    >
                      <option value="Inspector">Inspector</option>
                      {[
                        ...new Set(
                          progressSurveyData.map((user) => user.inspectedBy)
                        ),
                      ].map((inspectorItem, index) => (
                        <option key={index} value={inspectorItem}>
                          {inspectorItem}
                        </option>
                      ))}
                    </select> */}
                        <AutocompleteInput
                          masterList={inspectorProgressList}
                          getOptionLabel={(item) => item?.name || ""}
                          getOptionValue={(item) => item?.name || ""}
                          value={
                            InspectorProgress === "Inspector"
                              ? ""
                              : InspectorProgress
                          }
                          onValueChange={(value) =>
                            setInspectorProgress(value || "Inspector")
                          }
                          placeholder="Inspector(s)"
                          inputClassName="form-control"
                        />
                      </div>

                      <div
                        className="col-6 col-md-3"
                        style={{ width: "30.99%" }}
                      >
                        <select
                          className="form-select form-control status-dropdown "
                          // value={statusProgress}
                          value={
                            InspectorProgress === "Inspector"
                              ? ""
                              : InspectorProgress
                          }
                          onChange={(e) => setStatusProgress(e.target.value)}
                        >
                          <option value="Status">Status</option>
                          {[
                            ...new Set(progressData.map((user) => user.status)),
                          ].map((statusItem, index) => (
                            <option key={index} value={statusItem}>
                              {statusItem}
                            </option>
                          ))}
                        </select>
                      </div>

                      {isAnyFilterAppliedOnProgress && (
                        <div style={{ width: "auto", paddingLeft: "0px" }}>
                          <IconButton
                            onClick={() => {
                              setSearchTextProgress("");
                              setPropertyNameProgress("Property Name");
                              setInspectorProgress("Inspector");
                              setStatusProgress("Status");
                            }}
                          >
                            <ClearIcon
                              sx={{ color: "#717186" }}
                              fontSize="small"
                            />
                          </IconButton>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="inspection-table">
                    <DynamicTable
                      // tableData={progressData}
                      tableData={filteredRowsProgress}
                      columnsValue={progressColumns}
                      pageSize={10}
                      showSelectAll={true}
                      setSelectedIds={(ids) => {
                        setSelectedIds(ids);
                        console.log(selectedIds);

                        const selected = filteredRowsProgress.find(
                          (row) => row.id === ids?.[0],
                        );

                        setSelectedRow(selected || null);
                      }}
                    />
                  </div>
                </Col>

                {/* RIGHT → Completed */}
                <Col md={6}>
                  <div className="dashboard-bar py-3">
                    <h2 className="mt-0 mb-3 text-start fw-bold">
                      Approver Completed
                    </h2>
                    <div className="row align-items-center g-3 mt-1">
                      {/* Search Bar */}
                      <div className="row" style={{ marginLeft: "-15px" }}>
                        <div className="custom_toolbar_search col-md-8 ">
                          <img src={searchIcon} />
                          <input
                            type="text"
                            className="form-control custom_toolbar_control"
                            id="floatingInput"
                            placeholder="Search..."
                            value={searchTextCompleted}
                            onChange={(e) =>
                              setSearchTextCompleted(e.target.value)
                            }
                          />
                        </div>
                      </div>

                      {/* Dropdowns */}
                      <div className="col-6 col-md-4">
                        {/* <select
                      className="form-select form-control"
                      value={propertyNameCompleted}
                      onChange={(e) =>
                        setPropertyNameCompleted(e.target.value?.trim() ?? e.target.value)
                      }
                    >
                      <option value="Property Name">Property Name</option>
                      {[
                        ...new Set(
                          completedSurveyData
                            .map((user) => user.propertyName?.trim())
                            .filter(Boolean),
                        ),
                      ].map((propertyName, index) => (
                        <option key={index} value={propertyName}>
                          {propertyName}
                        </option>
                      ))}
                    </select> */}

                        <AutocompleteInput
                          masterList={propertyNameCompletedList}
                          getOptionLabel={(item) => item?.name || ""}
                          getOptionValue={(item) => item?.name || ""}
                          value={
                            propertyNameCompleted === "Property Name"
                              ? ""
                              : propertyNameCompleted
                          }
                          onValueChange={(value) =>
                            setPropertyNameCompleted(
                              value?.trim() || "Property Name",
                            )
                          }
                          placeholder="Building Name"
                          inputClassName="form-control"
                        />
                      </div>

                      <div className="col-6 col-md-3">
                        {/* <select
                      className="form-select form-control"
                      value={InspectorCompleted}
                      onChange={(e) => setInspectorCompleted(e.target.value)}
                    >
                      <option value="Inspector">Inspector</option>
                      {[
                        ...new Set(
                          completedSurveyData
                            .map((user) => user.inspectedBy)
                            .filter(Boolean),
                        ),
                      ].map((inspectorItem, index) => (
                        <option key={index} value={inspectorItem}>
                          {inspectorItem}
                        </option>
                      ))}
                    </select> */}

                        <AutocompleteInput
                          masterList={inspectorCompletedList}
                          getOptionLabel={(item) => item?.name || ""}
                          getOptionValue={(item) => item?.name || ""}
                          value={
                            InspectorCompleted === "Inspector"
                              ? ""
                              : InspectorCompleted
                          }
                          onValueChange={(value) =>
                            setInspectorCompleted(value || "Inspector")
                          }
                          placeholder="Inspector(s)"
                          inputClassName="form-control"
                        />
                      </div>
                      <div className="col-6 col-md-2">
                        <select
                          className="form-select form-control status-dropdown"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                        >
                          <option value="Date">Date</option>
                          {Array.from(
                            new Map(
                              completedDataList
                                .map((user) => user.approvalDueDate)
                                .filter(Boolean)
                                .map((dateItem) => {
                                  const day = toCalendarDay(dateItem);
                                  if (!day) return null;
                                  const dateObj = new Date(dateItem);
                                  const label =
                                    dateObj.toLocaleDateString("en-US");
                                  return [day, label];
                                })
                                .filter(Boolean),
                            ).entries(),
                          ).map(([value, label], index) => (
                            <option key={index} value={value}>
                              {label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div
                        className="col-6 col-md-3"
                        style={{ width: "17.99%" }}
                      >
                        <select
                          className="form-select form-control status-dropdown"
                          value={statusCompleted}
                          onChange={(e) => setStatusCompleted(e.target.value)}
                        >
                          <option value="Status">Status</option>
                          {[
                            ...new Set(
                              completedDataList
                                .map((user) => user.status)
                                .filter(Boolean),
                            ),
                          ].map((statusItem, index) => (
                            <option key={index} value={statusItem}>
                              {statusItem}
                            </option>
                          ))}
                        </select>
                      </div>
                      {isAnyFilterAppliedOnCompleted && (
                        <div style={{ width: "auto", paddingLeft: "0px" }}>
                          <IconButton
                            onClick={() => {
                              setSearchTextCompleted("");
                              setPropertyNameCompleted("Property Name");
                              setInspectorCompleted("Inspector");
                              setStatusCompleted("Status");
                              setDate("Date");
                            }}
                          >
                            <ClearIcon
                              sx={{ color: "#717186" }}
                              fontSize="small"
                            />
                          </IconButton>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="inspection-table">
                    <NewDynamicTable
                      // tableData={completedDataList}
                      tableData={filteredRowsCompleted}
                      columnsValue={completedColumns}
                      pageSize={10}
                    />
                  </div>
                </Col>
              </Row>

              {/* {filteredRows && (
                <div className="inspection-table">
                  <NewDynamicTable
                    tableData={filteredRows}
                    columnsValue={tableColumns}
                    pageSize={10}
                    pageSizeOptions={[
                      10,
                      100,
                      150,
                      200,
                      { value: -1, label: "All" },
                    ]}
                  />
                </div>
              )} */}

              {/* {filteredRows &&
                filteredRows?.map((item, index) => {
                  return (
                    <PropertyTile
                      key={index}
                      data={item}
                      userRole={userRole}
                      refreshPage={() => setRefresh((prev) => !prev)}
                    />
                  );
                })} */}
            </>
            {showModal && (
              <ApprovalApproverdash
                data={showPropertyAcceptDetails}
                isApprove={false}
                isDueDate={false}
                onClose={() => {
                  setShowModal(false);
                }}
                inspectionRefnumber={inspectionRefnumber}
              />
            )}

            {showApproveModal && (
              <ApprovalApproverdash
                data={showPropertyAcceptDetails}
                isApprove={true}
                isDueDate={false}
                onClose={() => {
                  setShowApproveModal(false);
                }}
                inspectionRefnumber={inspectionRefnumber}
              />
            )}
            {showPdfModal && pdfUrl && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: "100vh",
                  width: "100vw",
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  zIndex: 1050,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "90%",
                    maxHeight: "80vh",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      padding: "10px 15px",
                      borderBottom: "1px solid #ddd",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h5 className="modal-title mb-0">PDF Preview</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowPdfModal(false);
                        setPdfUrl(null);
                      }}
                    ></button>
                  </div>
                  <div style={{ height: "90vh", padding: 0 }}>
                    <Iframe
                      src={pdfUrl}
                      width="100%"
                      height="100%"
                      title="PDF Preview"
                      style={{
                        border: "none",
                        display: "block",
                        width: "100%",
                        height: "100%",
                      }}
                      frameBorder="0"
                    ></Iframe>
                  </div>
                </div>
              </div>
            )}
            {showPropertyImageModal && (
              <UploadPropertyImage
                propertyId={showPropertyImageDetails?.propertyMasterId}
                handleCancel={handleCancel}
                propertyName={showPropertyImageDetails?.propertyName}
                inspectionRefnumber={
                  showPropertyImageDetails?.inspectionReferenceNumber
                }
                handleSuccess={handleImageUploadSuccess}
              />
            )}
            {showAcceptPopup && (
              <div className="modal-overlay">
                <div
                  className="approval-modal-content"
                  style={{ height: "fit-content" }}
                >
                  <span className="close" onClick={handleCancelAccept}>
                    &times;
                  </span>
                  <h6 className="modal-header">Pending Inspector Acceptance</h6>{" "}
                  {/* Modal Header */}
                  <div className="modal-body">
                    <div>
                      <p>
                        Please Accept the scheduled inspection for property :{" "}
                        {showPropertyAcceptDetails.propertyName}
                      </p>

                      <div className="row">
                        <div className="col-sm-6 col-md-6 mb-3">
                          <div className="form-floating">
                            <select
                              className="form-select"
                              id="floatingSelect"
                              aria-label="Floating label select example"
                              value={acceptFormData.status}
                              onChange={handleStatusChange}
                            >
                              <option selected>Select</option>
                              <option value="Accepted">Accept</option>
                              <option value="Rejected">Reject</option>
                            </select>
                            <label htmlFor="floatingSelect">Status </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          rows="5"
                          style={{ minHeight: "auto", height: "auto" }}
                          placeholder="Comments"
                          value={acceptFormData.comment}
                          id="floatingTextarea"
                          name="comment"
                          onChange={(e) => handleFormDataChange(e)}
                        ></textarea>
                        <label htmlFor="floatingTextarea">
                          Comments{" "}
                          {acceptFormData.status == "Rejected" ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : (
                            ""
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="row mt-3" style={{ marginRight: "0px" }}>
                      {showLoader ? (
                        <div
                          className="approvalLoader"
                          style={{ marginLeft: "45%" }}
                        ></div>
                      ) : (
                        <div>
                          <div>
                            {" "}
                            {validationFlag && (
                              <small
                                style={{ color: "red", float: "left" }}
                                className=" mb-1"
                              >
                                * Please fill all required fields
                              </small>
                            )}
                          </div>
                          <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                            <button
                              type="button"
                              className="btn btn-tertiary"
                              onClick={() => {
                                handleCancelAccept();
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => handleAcceptValidation()}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <Menu
              anchorEl={downloadMenuAnchor}
              open={Boolean(downloadMenuAnchor)}
              onClose={handleDownloadMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <MenuItem
                onClick={() => {
                  handleDownloadMenuClose();
                  if (downloadMenuRow)
                    gotoPropertyView(
                      downloadMenuRow?.propertyMasterId,
                      downloadMenuRow,
                    );
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <img
                    src={activeViewIcon}
                    alt="View"
                    style={{ height: "20px", width: "20px" }}
                  />
                </ListItemIcon>
                <ListItemText>View</ListItemText>
              </MenuItem>
              {downloadMenuRow && checkShowDownloadicon(downloadMenuRow) && (
                <MenuItem
                  onClick={() => {
                    handleDownloadMenuClose();
                    if (downloadMenuRow) handleDownloadClick(downloadMenuRow);
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <img
                      src={activeDownloadIcon}
                      alt="Download PDF"
                      style={{ height: "20px", width: "20px" }}
                    />
                  </ListItemIcon>
                  <ListItemText>Download PDF</ListItemText>
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  if (downloadMenuRow) handleExportActionItems(downloadMenuRow);
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  {/* <TableChartIcon
                    fontSize="small"
                    sx={{ color: "#EF3800" }}
                  /> */}
                  <img
                    src={excelExportIcon}
                    alt="Export Excel"
                    style={{ height: "20px", width: "20px" }}
                  />
                </ListItemIcon>
                <ListItemText>Export Action Items</ListItemText>
              </MenuItem>
            </Menu>
            <LoadingComponent loading={loading} />
            {/* // )} */}
          </div>
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default ApproverDashboard;
